module.exports = __webpack_public_path__ + "img/cp_pdg.05779871.png";